module.exports = __webpack_public_path__ + "img/robot.aee32efe.png";